import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/admin/components/ui/card';
import { Button } from '@/admin/components/ui/button';
import { IconExternalLink, IconCoins } from '@tabler/icons-react';
import React from 'react';

const POSTHOG_DASHBOARD_URL =
  'https://us.posthog.com/project/252701/dashboard/1036963';

export const UsagePage: React.FC = () => {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-4 lg:p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-full bg-primary/10">
            <IconCoins className="size-6 text-primary" />
          </div>
          <CardTitle>Token Usage Analytics</CardTitle>
          <CardDescription>
            Detailed token usage analytics have been moved to our PostHog
            dashboard
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center gap-4">
          <p className="text-sm text-muted-foreground text-center">
            Click the button below to view detailed token usage statistics,
            including trends, model breakdown, and user activity.
          </p>
          <Button
            onClick={() => {
              window.open(POSTHOG_DASHBOARD_URL, '_blank');
            }}
            className="gap-2"
          >
            Open PostHog Dashboard
            <IconExternalLink className="size-4" />
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
